//@flow
import { withPropsOnChange, withProps } from 'recompose'
import { t } from './i18n'

type TranslationMap = {
  [propName: string]: string
}

type TranslationMapCreator = (props: Object) => TranslationMap

const withTranslations = (propMap: TranslationMap | TranslationMapCreator) => {
  // select withProps instead of withPropsOnChange([]) when asked for dynamic behaviour
  let hoc =
    typeof propMap === 'function'
      ? withProps
      : withPropsOnChange.bind(null, [[]])
  return hoc(ownProps => {
    let keyMapper
    if (typeof propMap === 'function') {
      keyMapper = propMap(ownProps)
    } else {
      keyMapper = propMap
    }
    return Object.keys(keyMapper).reduce((acc, propName) => {
      acc[propName] = t(keyMapper[propName])
      return acc
    }, {})
  })
}

export default withTranslations



// WEBPACK FOOTER //
// ./src/core/withTranslations.js